module.exports = __webpack_public_path__ + "static/media/handmade-leatherworking-tools-pro-series-tools.27a8b82e.jpg";